import { render, staticRenderFns } from "./ChipTooltip.vue?vue&type=template&id=31aa6933"
import script from "./ChipTooltip.vue?vue&type=script&lang=js"
export * from "./ChipTooltip.vue?vue&type=script&lang=js"
import style0 from "./ChipTooltip.vue?vue&type=style&index=0&id=31aa6933&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports